<template>
    <div class="">
        <el-page-header class="bg-color header_fixed p10 mb10" :style="{width: fixWidth}" @back="toListPage">
            <span slot="title" style="vertical-align: sub;">{{isView?'返回':'取消'}}</span>
            <p slot="content" class="font14px text-bold">{{isView?'查看':this.pageType=='edit'?'编辑':this.pageType=='copy'?'复制':'添加'}}角色
                <el-button v-if="isView" type="default" class="action-btn mr20" @click="toListPage">关闭</el-button>
                <el-button v-else type="primary" class="submit-btn action-btn ml20" :loading="submitLoading" @click="handleSubmit">保存</el-button>
            </p>
        </el-page-header>

        <div class="form-wrap role_create_body">
            <el-form ref="form" class="mt60" :model="formItem" :rules="rules" label-width="120px">
                <div class="bg-color mb10 pt10">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="角色名称：" prop="role_name" class="label-required mb10">
                                <el-input v-model.trim="formItem.role_name" :disabled="isView" placeholder="请输入角色名称，长度2-30位" maxlength="20" show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7" :xl="4">
                            <el-form-item label="角色类型：" prop="role_type" class="label-required mb10">
                                <ESelect v-model="formItem.role_type" :disabled="isView||!is_super_admin" filterable class="full-w" placeholder="请选择">
                                    <el-option
                                        v-for="item in roleTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        {{item.name}}
                                    </el-option>
                                </ESelect>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="说明：" class="mb10">
                                <el-input v-model.trim="formItem.note" :disabled="isView" :maxlength="30" placeholder="输入角色说明，方便区分与记忆"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                
                <div class="bg-color pt2 pl10 pr10">
                    <TitleLine num="1" class="mt10" title="数据权限设置"/>
                    <div class="data-setting pl20" v-loading="dataLoading">
                        <h3 class="form-item-title mt10">媒体账户权限配置</h3>
                        <el-form-item prop="plat_ids" label="" label-width="20px">
                            <div v-for="platItem in platConfig" :key="'platCompany'+platItem.id" class="mb6">
                                <el-checkbox :value="formItem.plat_ids.includes(platItem.id)" :label="platItem.id" @change="changePlatId(platItem.id,$event)" :disabled="isView||platItem.disabled" :key="platItem.id" name="type" style="width: 200px;">
                                    {{platItem.name}}
                                </el-checkbox>
                                <el-radio-group v-model="formItem.plat_company[platItem.id]" :disabled="isView||!formItem.plat_ids.includes(platItem.id)">
                                    <el-radio v-for="item in platCompanyConfig[platItem.id]" :label="''+item.id" :disabled="item.disabled" :key="item.id">{{item.name}}
                                    </el-radio>
                                </el-radio-group>
                            </div>
                        </el-form-item>


                        <h3 class="form-item-title" >数据日期权限配置</h3>
                        <el-form-item prop="data_days" label-width="20px">
                            <el-radio-group v-model="formItem.data_days_type" @change="changeDataDaysType" :disabled="isView">
                                <el-radio label="1">整体配置</el-radio>
                                <el-radio label="2">分模块配置</el-radio>
                            </el-radio-group>

                            <div v-if="formItem.data_days_type=='1'">
                                <el-radio-group v-model="formItem.data_days_global" @change="changeDataDaysGlobal" :disabled="isView">
                                    <el-radio label="1">最近
                                        <el-input v-model="formItem.data_days" size="mini" :disabled="isView||formItem.data_days_global=='2'" style="width: 60px;"></el-input>
                                        天</el-radio>
                                    <el-radio label="2">不限</el-radio>
                                </el-radio-group>
                            </div>
                            <div v-else>
                                <span class="font12px text-color">请在【页面与操作权限配置】各模块处配置</span>
                            </div>
                        </el-form-item>
                        <h3 class="form-item-title mt10">其他权限</h3>
                        <el-form-item prop="data_days" label-width="20px">
                            <el-checkbox v-model="formItem.department_data_permission_tips" true-label="1" false-label="0" :disabled="isView">部门数据权限内标签维护提示
                                <el-tooltip placement="right">
                                    <div slot="content" style="max-width: 300px;">
                                        <p class="mb10">影响成员登录时，产品未维护标签信息（如IAA、IAP）时的强提醒。</p>
                                        <p class="mb10">* 若勾选，则部门数据权限内的其他成员负责的产品需要提醒时，会给当前角色的成员触发时也提醒。</p>
                                        <p>* 组长&上级负责人酌情选中此功能即可。</p>
                                    </div>
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-checkbox>
                        </el-form-item>
                    </div>
                    
                    <el-tabs v-model="activeSystem" @tab-click="changeActiveSystem">
                        <el-tab-pane v-for="page in systemList" :label="page.label" :name="page.value" :key="page.value">
                        </el-tab-pane>
                    </el-tabs>
                    <el-form-item  label-width="20px" v-if="activeSystem=='weapp'">
                            <el-checkbox v-model="formItem.allow_mp" true-label="1" false-label="0" :disabled="isView">允许访问小程序
                            </el-checkbox>
                    </el-form-item>

                    <TitleLine num="2" title="页面与操作权限"/>
                    <el-form-item label-width="20px" v-loading="dataLoading">
                        <el-tabs v-model="activePageName">
                            <el-tab-pane v-for="page in operationConfigList" :label="page.display_name" :name="page.name" :key="page.id">
                                <div slot="label">
                                <span @click.stop>
                                     <el-checkbox v-model="page.checked" :disabled="isView" class="pr6" @change="val=>changeCurModule(page,val)" ></el-checkbox>
                                </span>
                                    <span :class="[page.checked?'text-color-primary':'']">{{page.display_name}}</span>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <p class="tool-bar pl20 mb6">
                            <CheckAllBtn :data="activePageModule" :is-view="isView" @change="checkAllChange"/>
                        </p>

                        <div class="ml20 mb50 border-top" style="min-height: 650px;">
                            <template v-for="module in activePageModule.children||[]">
                                <ModuleTitle
                                    v-if="module.children&&module.children.length>0"
                                    :module="module"
                                    :is-view="isView"
                                    :data-days="formItem.data_days_type"
                                    @check-all-change="checkAllChange"
                                    @check-parents="checkModuleParents"
                                >
                                    <div class="ml20">
                                        <ModuleContent
                                            v-for="page in module.children"
                                            :module="page"
                                            :is-view="isView"
                                            :data-days="formItem.data_days_type"
                                            :period-config="periodConfig"
                                            :tag-editable="tagActionIdsEditable"
                                            :role-list="configRoleList"
                                            :table-list="configOptionalTableList"
                                            :specialConfig="formItem.special_config"
                                            @check-all-change="checkAllChange"
                                            @check-parents="checkModuleParents"
                                            @save-dimension="saveDimension"
                                            @save-field="saveField"
                                            @save-roles="saveOptionRole"
                                            @save-tables="saveOptionTable"
                                            @save-tag-fields="saveTagFields"
                                            @save-period="savePeriod"
                                            @auto-check-func="autoCheckFunc"
                                            @save-notifier="saveNotifier"
                                            @save-retry-data="handleSaveRetryData"
                                            @save-data-permission="handleSaveDataPermissionData"
                                            @save-adjustment="handleSaveAdjustment"
                                        ></ModuleContent>
                                    </div>
                                </ModuleTitle>
                                <ModuleContent
                                    v-else
                                    :module="module"
                                    :is-view="isView"
                                    :data-days="formItem.data_days_type"
                                    :period-config="periodConfig"
                                    :tag-editable="tagActionIdsEditable"
                                    :role-list="configRoleList"
                                    :table-list="configOptionalTableList"
                                    :specialConfig="formItem.special_config"
                                    @check-all-change="checkAllChange"
                                    @check-parents="checkModuleParents"
                                    @save-dimension="saveDimension"
                                    @save-field="saveField"
                                    @save-roles="saveOptionRole"
                                    @save-tables="saveOptionTable"
                                    @save-tag-fields="saveTagFields"
                                    @save-period="savePeriod"
                                    @auto-check-func="autoCheckFunc"
                                    @save-notifier="saveNotifier"
                                    @save-retry-data="handleSaveRetryData"
                                    @save-data-permission="handleSaveDataPermissionData"
                                    @save-adjustment="handleSaveAdjustment"
                                ></ModuleContent>
                            </template>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import TitleLine from '../components/roleNew/title-line.vue';
    import API from '@/api/role.js';
    import utils from '@/libs/utils.js';
    import {platMap} from '@/constant/index.js';
    import ModuleTitle from '../components/roleNew/moduleTitle.vue';
    import ModuleContent from '../components/roleNew/moduleContent.vue';
    import CheckAllBtn from '../components/roleNew/checkAllBtn.vue';

    export default {
        name: "RoleConfig1",
        components: {
            TitleLine,
            ModuleTitle,
            ModuleContent,
            CheckAllBtn,
        },
        data() {
            let _this = this;
            let validateEmoji = (rule, value, callback)=>{
                let reg = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
                if(reg.test(value)){
                    callback(new Error('不可输入表情'));
                }else{
                    callback();
                }
            };
            let validateDataDays = (rule, value, callback)=>{
                if(_this.formItem.data_days_type=='2'){
                    callback();
                }else{
                    if(_this.formItem.data_days_global=='2'){
                        callback();
                    }else{
                        if(!value){
                            callback(new Error('天数不可为空'));
                        }else if(isNaN(value)){
                            callback(new Error('天数格式不正确'));
                        }else if(value<=0){
                            callback(new Error('天数需大于0'));
                        }else if(value>1000){
                            callback(new Error('最大不大于1000'));
                        }else if(parseInt(value)!=value){
                            callback(new Error('请填写整数'));
                        }else{
                            callback();
                        }
                    }
                }
            };
            return {
                fixWidth: '1000px',
                roleId: null,
                pageType:'',    // 'view-查看',add-添加,copy-复制
                submitLoading: false,
                dataLoading:false,
                formItem: {
                    department_data_permission_tips:'',
                    role_name: '',
                    role_type: '',
                    note: '',
                    plat_ids: [],
                    plat_company: {},
                    data_type: {},
                    dimension_type: {},
                    action_ids: [],
                    role_action: {},
                    sub_data_days:{},
                    special_config:{
                        optional_role:'',
                        optional_config_table:[],
                        tag_action_ids_editable:'',
                        statistical_period:{
                            customize_the_latest_days:'',
                            customize_the_start_date:'',
                        },
                    },
                    data_days_type:'1',      //1-整体配置，2-分模块配置
                    data_days:null,
                    data_days_global:'1',
                    allow_mp: '0'
                },
                rules: {
                    role_name: [
                        {required: true, message: '请输入角色名称', trigger: 'blur'},
                        {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'},
                        { validator: validateEmoji, trigger: 'blur' },
                    ],
                    role_type: [
                        {required: true, message: '请选择角色类型', trigger: 'blur'},
                    ],
                    plat_ids: [
                        {type: 'array', required: true, message: '请至少选择一个媒体', trigger: 'change'}
                    ],
                    data_days:[
                        { validator: validateDataDays, trigger: 'blur' },
                    ],
                },
                roleTypeList: [],   //
                platCompanyConfig: {},   // 1-全部账户 2-按照客户管理绑定
                platConfig: [],      // 1-OPPO 3-vivo 4-华为 7-mi
                operationConfig: [],     // 页面与操作权限配置
                activePageName: '',
                tagActionIdsEditable:{},      // 单独存放tag标签页面的字段可编辑的值
                configRoleList:[],
                configOptionalTableList:[],
                systemList: [
                    {
                        value: 'pc',
                        label: 'PC端系统',
                    },
                    {
                        value: 'weapp',
                        label: '小程序',
                    },
                ],
                activeSystem: 'pc',
            }
        },
        provide () {
            return {
                pageType:this.pageType,
            };
        },
        computed: {
            ...mapGetters(['is_super_admin','sidebar']),
            isView(){
                return this.pageType==='view';
            },
            isCopy(){
                return this.pageType==='copy';
            },
            activePageModule(){
                return this.operationConfig.find(item=>item.name==this.activePageName)||{};
            },
            periodConfig(){
                return this.formItem.special_config.statistical_period||{};
            },
            operationConfigList(){
                return this.operationConfig.filter(item=> {
                    if(item.is_mp){
                        return this.activeSystem==='weapp';
                    }
                    return this.activeSystem==='pc';
                });
            },
        },
        watch:{
            sidebar: {
                handler(){
                    setTimeout(()=>{
                        this.getFixWidth()
                    }, 200)
                },
                deep: true
            },
        },
        created() {
            let routeQuery = this.$route.query || {};
            this.roleId = routeQuery.role_id || null;
            this.pageType = routeQuery.type || '';

            this.getConfig();
            this.getRoleType();
        },
        mounted(){
            this.getFixWidth();
            window.addEventListener('resize', this.getFixWidth);
        },
        methods: {
            changeActiveSystem(val) {
                this.activePageName = this.operationConfigList[0].name||'';
            },
            getFixWidth() {
                let create_body = document.querySelector('.role_create_body');
                if(create_body) {
                    let mi_width = create_body.clientWidth;
                    this.fixWidth = `${mi_width}px`;
                }
            },
            getRoleType() {
                API.getRoleType({
                    id:this.roleId||'',
                }).then(res => {
                    let resData = res.data || {};
                    this.roleTypeList = resData || [];

                    if(!this.roleId&&this.roleTypeList.length==1){
                        this.formItem.role_type = this.roleTypeList[0].id;
                    }
                }, (err) => {
                    console.log('getRoleType error', err);
                    this.roleTypeList = [];
                });
            },
            getRoleInfo(type) {
                let apiUrl = 'getRoleInfo';
                if(type&&type=='copy'){
                    apiUrl = 'getCopyRoleInfo';
                }
                return API[apiUrl]({
                    role_id: this.roleId
                }).then(res => {
                    let resData = res.data || {};
                    this.formItem.role_name = resData.role_name;
                    this.formItem.role_type = resData.role_type;
                    this.formItem.note = resData.note;
                    this.formItem.department_data_permission_tips = resData.department_data_permission_tips;
                    this.formItem.plat_ids = resData.plat_ids.split(',');
                    this.formItem.data_days_type = resData.data_days_type||'1';      //1-整体配置，2-分模块配置
                    this.formItem.allow_mp = resData.allow_mp ||'0';
                    if(!resData.data_days||resData.data_days==null||resData.data_days==-1){
                        this.formItem.data_days = null;
                        this.formItem.data_days_global = '2';
                    }else {
                        this.formItem.data_days = resData.data_days;
                        this.formItem.data_days_global = '1';
                    }

                    /*
                    data_days_type:'1',      //1-整体配置，2-分模块配置
                    data_days:null,
                    data_days_global:'1',*/     //   1-天数 2-不限

                    let platCompany = JSON.parse(resData.plat_company||"{}") || {};
                    let roleAction = JSON.parse(resData.role_action||"{}") || {};
                    let subDataDays = JSON.parse(resData.sub_data_days||"{}") || {};
                    let specialConfig = JSON.parse(resData.special_config||"{}")||{};
                    let optionalRole = specialConfig.optional_role||'';
                    let tagActionIdsEditable = specialConfig.tag_action_ids_editable||{};
                    let statisticalPeriod = specialConfig.statistical_period||{};
                    let optionalConfigTable = specialConfig.optional_config_table||[];

                    for (let plat in platCompany) {
                        this.$set(this.formItem.plat_company, '' + plat, platCompany[plat] || '2');
                    }
                    this.formItem.role_action = roleAction;
                    this.formItem.sub_data_days = subDataDays;

                    this.formItem.action_ids = resData.action_ids.split(',');
                    this.formItem.special_config.optional_role = optionalRole;
                    this.formItem.special_config.retry_period = specialConfig.retry_period;
                    this.formItem.special_config.optional_config_table = optionalConfigTable;

                    if(statisticalPeriod.customize_the_latest_days){
                        this.formItem.special_config.statistical_period.customize_the_latest_days = statisticalPeriod.customize_the_latest_days;
                    }
                    if(statisticalPeriod.customize_the_start_date){
                        this.formItem.special_config.statistical_period.customize_the_start_date = statisticalPeriod.customize_the_start_date;
                    }
                    this.tagActionIdsEditable = tagActionIdsEditable;
                    this.initConfigData();

                }, (err) => {
                    console.log('getRoleInfo error', err);
                    this.$message.error(err.info || '操作失败')
                });
            },
            initConfigData() {
                this.operationConfig = this._fmtTreeData(this.operationConfig);
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    this.$set(v, 'checked', this.formItem.action_ids.includes(v.id)||v.default_check=='1');
                    if (v.children && v.children.length > 0) {
                        this._fmtTreeData(v.children)
                    }

                    /* 页面节点 */
                    if (v.type == '1') {
                        if (v.func && v.func.length > 0) {
                            this._fmtTreeData(v.func)
                        }
                        if (v.fields && v.fields.length > 0) {
                            this._fmtTreeData(v.fields)
                        }
                        if (v.dimension && v.dimension.length > 0) {
                            this._fmtTreeData(v.dimension)
                        }
                        if (v.notifier && v.notifier.length > 0) {
                            this._fmtTreeData(v.notifier)
                        }
                        if(v.special_func&&v.special_func.length>0){
                            let specialFuncArr = v.special_func||[];
                            if(specialFuncArr.findIndex(item=>item.name=='optional_role')!='-1'){
                                let formOptionalRole = this.formItem.special_config.optional_role;
                                this.$set(v, 'optional_role_val', formOptionalRole.length>0?formOptionalRole.split(','):[]);
                            }
                            if(specialFuncArr.findIndex(item=>item.name=='optional_config_table')!='-1'){
                                let formOptionalTable = this.formItem.special_config.optional_config_table;
                                this.$set(v, 'optional_config_table_val', formOptionalTable.length>0?formOptionalTable.split(','):[]);
                            }
                        }
                        if(v.optional_config_table&&v.optional_config_table.length>0){

                        }
                        if(v.statistical_period&&v.statistical_period.length>0){
                            this._fmtTreeData(v.statistical_period);
                        }
                        if (v.data_permission && v.data_permission.length > 0) {
                            this._fmtTreeData(v.data_permission)
                        }

                        if(v.adjustment_operation && v.adjustment_operation.length > 0) {
                            this._fmtTreeData(v.adjustment_operation)
                        }

                        // 需要选中全部数据的页面
                        const allDataPageList = [
                            'file_whitelist_page',
                            'file_separate_queue_page',
                            'project_management_page1',
                            'plat_management_page',
                            'creative_team_list',
                            'size_list',
                            'video_tag_list',
                            'img_tag_list',
                            'material_compare_page',
                            'work_order_label_list'
                        ];
                        this.$set(v, 'role_action', this.formItem.role_action[v.id] || (allDataPageList.includes(v.name)?'1':'2'));
                    }
                    if(['material_query_analysis', 'data_query_analysis'].includes(v.name) ){
                        let subDataDays = this.formItem.sub_data_days[v.id];
                        if(this.pageType == 'add'){
                            this.$set(v, 'data_days',  null);
                            this.$set(v, 'data_days_global',  '1');
                        }else if(subDataDays==''||subDataDays==null||subDataDays==-1){
                            this.$set(v, 'data_days',  null);
                            this.$set(v, 'data_days_global',  '2');
                        }else{
                            this.$set(v, 'data_days',  subDataDays);
                            this.$set(v, 'data_days_global',  '1');
                        }
                    }
                });
                return data;
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _findModuleByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _getCheckedVal(list=[],result){
                list.forEach(item=>{
                    // console.log('list.forEach',item.display_name,item.id,item.checked,result);
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        if(item.children.some(item=>item.checked)){
                            result.push(item.id);
                        }
                        return this._getCheckedVal(item.children,result);
                    }
                    if(item.type=='1'&&item.checked){
                        let func = this._getCheckedVal(item.func,result);
                        let fields = this._getCheckedVal(item.fields,result);
                        let dimension = this._getCheckedVal(item.dimension,result);
                        let notifier = this._getCheckedVal(item.notifier,result);
                        let period = this._getCheckedVal(item.statistical_period||[],result);
                        let data_permission = this._getCheckedVal(item.data_permission||[],result);
                        let adjustment_operation = this._getCheckedVal(item.adjustment_operation,result);
                        result.concat(func,fields,dimension,notifier,period,adjustment_operation, data_permission);
                    }
                });
                return result;
            },
            _getRoleActionVal(list,result){
                list.forEach(item=>{
                    if(item.type=='1'&&item.checked){
                        result[item.id] = item.role_action;
                    }else if(item.children&&item.children.length>0){
                        return this._getRoleActionVal(item.children,result);
                    }
                });
                return result;
            },
            _getSubDataDaysVal(list,result){
                list.forEach(item=>{
                    if(['material_query_analysis', 'data_query_analysis'].includes(item.name)&&item.checked){
                        if(item.data_days_global=='2'){
                            result[item.id] = '-1';
                        }else{
                            result[item.id] = item.data_days;
                        }

                    }else if(item.children&&item.children.length>0){
                        return this._getSubDataDaysVal(item.children,result);
                    }
                });
                return result;
            },
            _setChildrenVal(module,val){
                if(!module.disabled){
                    this.$set(module,'checked',val);
                }
                if(module.children&&module.children.length>0){
                    let pModule = this._findModuleById(this.operationConfig,module.id);
                    if(pModule&&pModule.name=='daily_task_page'){
                        let plat = (module.name||'').replace('data_','');
                        let platDimension = module.children||[];
                        if(plat){
                            let formDimension = this.formItem.dimension_type[plat]||[];
                            platDimension.forEach(inner=>{
                                if(formDimension.includes(inner.mid)){
                                    this._setChildrenVal(inner,val);
                                }
                            })
                        }
                    }else{
                        let children = module.children;
                        children.forEach(child=>{
                            this._setChildrenVal(child,val);
                        })
                    }
                }
                if(module.type=='1'){

                    /*判断是不是综合查询分析的子页面*/
                    let isPlatDataQueryAnalysisPage = module.pid=='73';
                    let modulePlatId = null;
                    let platDimensionType = [];
                    let platDataType = [];
                    let checkedPlat = this.formItem.plat_ids;
                    if(isPlatDataQueryAnalysisPage){
                        let moduleNameData = (module.name||'').split('_');
                        let platData = moduleNameData.length>1?moduleNameData[1]:'';
                        let platId = platData.match(/\d+(\.\d+)?/g)||[];
                        modulePlatId = platId[0]||'';
                        // console.log('modulePlatId',modulePlatId);
                    }
                    if(modulePlatId){
                        platDataType = this.formItem.data_type[modulePlatId];
                        platDimensionType = this.formItem.dimension_type[modulePlatId];

                        let isCheckedPlat = checkedPlat.includes(modulePlatId);
                        if(isCheckedPlat){
                            if(module.fields&&module.fields.length>0){
                                let fields = module.fields;
                                fields.forEach(item=>{
                                    if(platDataType.includes(item.mid)){
                                        this._setFieldsChildrenVal(item,true);
                                    }else{
                                        this._setFieldsChildrenVal(item,false);
                                    }
                                })
                            }
                            if(module.dimension&&module.dimension.length>0&&checkedPlat.includes(modulePlatId)){
                                let dimension = module.dimension;
                                dimension.forEach(item=>{
                                    if(platDimensionType.includes(item.mid)){
                                        this._setFieldsChildrenVal(item,true);
                                    }else{
                                        this._setFieldsChildrenVal(item,false);
                                    }
                                })
                            }
                        }else{
                            this._setFieldsChildrenVal(module,false);
                        }

                    }else{
                        /* 判断是不是推广管理-Apple下的tab页面 */
                        let isApplbTabs = ['apple_org','apple_campaign','apple_adgroup','apple_keyword','apple_search_term','apple_negative_keyword'].includes(module.name);

                        if(isApplbTabs){
                            /* 判断苹果渠道的数据类型权限字段 */
                            let fields = module.fields||[];
                            let platDataType = this.formItem.data_type['9']||[];
                            fields.forEach(item=>{
                                this._setChildrenVal(item,platDataType.includes(item.mid));
                            })
                        }else{
                            if(module.fields&&module.fields.length>0){
                                let fields = module.fields;
                                fields.forEach(item=>{
                                    this._setChildrenVal(item,val);
                                })
                            }
                        }
                        if(module.dimension&&module.dimension.length>0){
                            let dimension = module.dimension;

                            /*单独处理【自动化报告】页面的维度*/
                            if(module.name=='daily_task_page'){
                                dimension.forEach(platData=>{
                                    let plat = (platData.name||'').replace('data_','');
                                    let platDimension = platData.children||[];
                                    if(plat){
                                        let formDimension = this.formItem.dimension_type[plat]||[];
                                        platDimension.forEach(inner=>{
                                            if(formDimension.includes(inner.mid)){
                                                this._setChildrenVal(inner,val);
                                            }
                                        });
                                        if(val&&formDimension.length>0){
                                            this.$set(platData,'checked',true)
                                        }
                                    }
                                })
                            }else{
                                dimension.forEach(item=>{
                                    this._setChildrenVal(item,val);
                                })
                            }
                        }
                    }

                    if(module.func&&module.func.length>0){
                        let func = module.func;
                        func.forEach(item=>{
                            this._setChildrenVal(item,val);
                        })
                    }

                    /*自动化报告-统计周期权限设置*/
                    if(module.statistical_period&&module.statistical_period.length>0){
                        if(val){
                            /*选中 第一项*/
                            this._setChildrenVal(module.statistical_period[0],val);
                        }else{
                            /*取消选中*/
                            let period = module.statistical_period;
                            period.forEach(item=>{
                                this._setChildrenVal(item,val);
                            })
                        }
                    }
                }
            },
            _setFieldsChildrenVal(field,val){
                if(!field) return;
                if(!field.disabled){
                    this.$set(field,'checked',val);
                }
                let children = field.children||[];
                children.forEach(item=>{
                    this._setFieldsChildrenVal(item,val);
                })
            },
            getConfig() {
                this.dataLoading = true;
                return API.getAddRoleConfig().then(res => {
                    let resData = res.data || {};

                    let permConfig = resData.data_config.perm_config||[];

                    permConfig.forEach(item=>{
                        this.platCompanyConfig[item.plat_id] = (item.plat_company_config||[]).sort((a,b)=>b.id-a.id);
                    });
                    this.platConfig =  resData.data_config.plat_config || [];
                    this.operationConfig = [...(resData.operation_config || []), ...(resData.mp_operation_config || []).map((v)=> {
                        return {
                            ...v,
                            is_mp: true,
                        }
                    })];
                    this.activePageName = this.operationConfig.map(item=>item.name)[0];
                    // const LIST = (function restArr(list = resData.operation_config) {
                    //     const arrs = []
                    //     list.forEach(v=> {
                    //         arrs.push(v);
                    //         if (v.children && v.children.length) {
                    //           arrs.push(...restArr(v.children));
                    //         }
                    //     });
                    //     return arrs
                    // })();
                    // const DATA =  LIST.reduce((pre, item)=> {
                    //    if (!pre[item.name]) {
                    //      pre[item.name] = 1
                    //    }else {
                    //     ++pre[item.name]
                    //    }
                    //     return pre;
                    // }, {})
                    // console.log(DATA, 'DATA');

                    /*添加角色时 默认勾选首页并且不可取消*/
                    let homePage = this.operationConfig.find(item=>item.name=='home');
                    if(homePage){
                        this.$set(homePage,'checked',true);
                        this.$set(homePage,'disabled',true);
                        this.$set(homePage,'auto_check',true);
                        this.$set(homePage,'default_check',true);
                    }
                    /*配置可选角色时会用到*/
                    this.$store.commit('roleData/SET_ROLE_LIST', resData.role_list || []);
                    this.configRoleList = resData.role_list || [];

                    /*配置表会用到  optional_config_table*/
                    this.$store.commit('roleData/SET_OPTIONAL_TABLE_LIST', resData.optional_config_table || []);
                    this.configOptionalTableList = resData.optional_config_table || [];

                    // this.formItem.plat_ids = this.platConfig.filter(item=>!item.disabled).map(item => item.id);

                    /*先设置默认值*/
                    this.platConfig.forEach(item => {
                        this.$set(this.formItem.plat_company, item.id, '2');    //默认按照账户绑定与授权
                        this.$set(this.formItem.data_type, item.id, []);    //默认选中广告投放数据
                        this.$set(this.formItem.dimension_type, item.id, []);    //
                    });

                    this.$nextTick(()=>{
                        if (this.roleId) {
                            if(this.isCopy){
                                this.getRoleInfo('copy').then(()=>{
                                    this.dataLoading = false;
                                }).catch(()=>{
                                    this.dataLoading = false;
                                });
                            }else{
                                this.getRoleInfo().then(()=>{
                                    this.dataLoading = false;
                                }).catch(()=>{
                                    this.dataLoading = false;
                                });
                            }
                        }else{
                            this.initConfigData();
                            this.dataLoading = false;
                        }
                    })


                }, (err) => {
                    console.log('getConfig error', err);
                    this.platCompanyConfig = {};
                    this.platConfig = [];
                    this.operationConfig = [];
                    this.dataLoading = false;
                });
            },
            toListPage() {
                this.$emit('togglePage');
                let routeParams = this.$route.params || {};
                let original = routeParams.original;
                this.$router.replace({
                    name: 'role_management',
                    query: {
                        action: 'list',
                        t: +new Date(),
                    },
                    params:{
                        original:original,
                    }
                });
            },
            handleSubmit() {
                this.$refs['form'].validate((valid)=>{
                    if(valid){

                        let platsChecked = this.formItem.plat_ids;
                        let platCompanyChecked = {};
                        let dataTypeChecked = {};
                        let dimensionTypeChecked= {};

                        platsChecked.forEach(item=>{
                            platCompanyChecked[item] = this.formItem.plat_company[item];
                            dataTypeChecked[item] = this.formItem.data_type[item].join(',');
                            dimensionTypeChecked[item] = this.formItem.dimension_type[item].join(',');
                        });

                        let data = {
                            role_name: this.formItem.role_name,
                            role_type: this.formItem.role_type || '1',
                            note: this.formItem.note,
                            plat_ids: this.formItem.plat_ids.join(','),
                            data_days_type:this.formItem.data_days_type,
                            allow_mp:this.formItem.allow_mp,
                            plat_company: JSON.stringify(platCompanyChecked),
                            data_type: JSON.stringify(dataTypeChecked),
                            dimension_type: JSON.stringify(dimensionTypeChecked),
                            department_data_permission_tips:this.formItem.department_data_permission_tips,
                        };

                        if(this.formItem.data_days_type=='1'){
                            data.data_days = this.formItem.data_days||'-1';
                        }else{
                            //json,各模块对应的日期权限
                            let subDataDays = this._getSubDataDaysVal(this.operationConfig,{});
                            if(Object.values(subDataDays).some(item=>item<=0&&item!=-1)){
                                return this.$message.error('分模块数据日期权限配置：天数需大于0');
                            }
                            data.sub_data_days =  JSON.stringify(subDataDays);
                        }

                        // 权限id '13,14,15,32,16,17,18'
                        let actionIds = this._getCheckedVal(this.operationConfig,[]);
                        if(actionIds.length<=0){
                            return this.$message.error('请选择模块、页面、操作权限');
                        }


                        // 校验是否选了【自动化日报】&&设置了【统计周期权限】
                        let $dailyTaskPage = this._findModuleByName(this.operationConfig,'daily_task_page');
                        // console.log('$dailyTaskPage',$dailyTaskPage);
                        if($dailyTaskPage&&actionIds.includes($dailyTaskPage.id)){
                            let pageStatisticalPeriod = $dailyTaskPage.statistical_period||[];
                            if(pageStatisticalPeriod.length>0&&pageStatisticalPeriod.every(item=>!item.checked)){
                                return this.$message.error('请设置自动化日报的统计周期权限');
                            }
                        }

                        // 校验是否选了【工单管理】-素材库页面&&设置了【数据权限】
                        let $materialListPage = this._findModuleByName(this.operationConfig,'material_list');
                        let $parentPage =  this._findModuleById(this.operationConfig,$materialListPage.pid);
                        if($parentPage.name=='material'&&actionIds.includes($materialListPage.id)){
                            let pageDataPermission = $materialListPage.data_permission||[];
                            if(pageDataPermission.length>0&&pageDataPermission.every(item=>!item.checked)){
                                return this.$message.error('请设置工单管理素材库页面的数据权限');
                            }
                        }

                        this.formItem.special_config.tag_action_ids_editable = this.tagActionIdsEditable;
                        data.special_config = JSON.stringify(this.formItem.special_config);

                        //json,各模块对应的数据权限
                        let roleAction = this._getRoleActionVal(this.operationConfig,{});


                        data.action_ids = utils.unique(actionIds).join(',');
                        data.role_action = JSON.stringify(roleAction);

                        this.submitLoading = true;

                        /* 编辑角色 */
                        if (this.roleId&&!this.isCopy) {
                            data.role_id = this.roleId;
                            API.editRole(data).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.submitLoading = false;
                                this.toListPage();
                            }, (err) => {
                                console.log('addRole error', err);
                                this.$message.error(err.info || '操作失败');
                                this.submitLoading = false;
                            });

                        } else {
                            /* 添加角色*/
                            API.addRole(data).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.submitLoading = false;
                                this.toListPage();
                            }, (err) => {
                                console.log('addRole error', err);
                                this.$message.error(err.info || '操作失败');
                                this.submitLoading = false;
                            });
                        }
                    }else{
                        this.$message.error('表单数据填写有误，请检查后重新提交');
                    }
                })


            },
            changeDataDaysGlobal(val){
                this.formItem.data_days = null;
                this.$refs.form.clearValidate('data_days');
            },
            changeDataDaysType(val){
                if(val=='2'){
                    let mDataCenterAnalysis = this._findModuleByName(this.operationConfig,'data_query_analysis');
                    if(!mDataCenterAnalysis) return;
                    this.$set(mDataCenterAnalysis,'data_days_global','1');
                    this.$set(mDataCenterAnalysis,'data_days',null);
                }else if(val=='1'){
                    this.formItem.data_days_global = '1';
                    this.formItem.data_days = null;
                }
                this.$refs.form.clearValidate('data_days');
            },
            changePlatId(id,val){
                console.log('changePlatId',id,val);
                if(val){
                    if(!this.formItem.plat_ids.includes(id)){
                        this.formItem.plat_ids.push(id);
                    }
                }else{
                    let index = this.formItem.plat_ids.findIndex(item=>item == id);
                    if(index!=-1){
                        this.formItem.plat_ids.splice(index,1);
                    }
                }
            },
            changeCurModule(page,val){
                console.log('changeCurModule',page,val);
                if(val===false&&page.default_check=='1'){
                    page.checked = true;
                    this.$message.error(page.display_name+'：该项为必选项');
                }else if(val===false){
                    this.checkAllChange(page,false);
                }
            },
            checkAllChange(data,val){
                if(data.disabled&&data.name!='home') return console.log('不可操作');
                if(val===false&&(data.default_check=='1')){
                    this.$message.error(data.display_name+'：该项为必选项');
                    this.$set(data,'checked',true);
                }else{
                    this.$set(data,'checked',val);
                    let pid = data.pid;
                    if(val&&pid&&pid!='0'){
                        this.checkModuleParents(data.pid);
                    }
                }

                /* type-1：页面 ，type-0：模块  */
                if(data.type=='1'){
                    if(data.dimension&&data.dimension.length>0){
                        data.dimension.forEach(item=>{
                            this._setFieldsChildrenVal(item,val);
                        })
                    }
                    if(data.func&&data.func.length>0){
                        let func = data.func;
                        func.forEach(item=>{
                            this._setFieldsChildrenVal(item,val);
                        })
                    }
                    if(data.fields&&data.fields.length>0){
                        let fields = data.fields;
                        fields.forEach(item=>{
                            this._setFieldsChildrenVal(item,val);
                        })
                    }
                    if(data.notifier&&data.notifier.length>0){
                        let fields = data.notifier;
                        fields.forEach(item=>{
                            this._setFieldsChildrenVal(item,val);
                        })
                    }

                    /*自动化报告-统计周期权限设置*/
                    if(data.statistical_period&&data.statistical_period.length>0){
                        if(val){
                            /*选中 第一项*/
                            let firstItem = data.statistical_period[0];
                            if(firstItem&&!firstItem.disabled){
                                this.$set(firstItem,'checked',true);
                            }
                        }else{
                            /*取消选中*/
                            let period = data.statistical_period;
                            period.forEach(item=>{
                                this.$set(item,'checked',false);
                            })
                            this.formItem.special_config.statistical_period.customize_the_latest_days = '';
                            this.formItem.special_config.statistical_period.customize_the_start_date = '';
                        }
                    }

                    /* 处理权限管理 配置可选角色的值 */
                    if(data.name == 'organization_management_page'&&val===false){
                        this.formItem.special_config.optional_role = '';
                        data.optional_role_val = [];
                    }
                    /* 处理配置管理 配置可查看配置表的值 */
                    if(data.name == 'config_manage_page'&&val===false){
                        this.formItem.special_config.optional_table = '';
                        data.optional_table_val = [];
                    }

                    /* 处理工单管理素材库页面的数据权限的值 */
                    if(data.name == 'material_list'&&val===false){
                        let actionPage = this._findModuleById(this.operationConfig,data.id);
                        if(actionPage&&actionPage.data_permission&&actionPage.data_permission.length>0){
                            actionPage.data_permission.forEach(item=>{
                                this.$set(item,'checked',false);
                            })
                        }
                    }



                    /* 处理 标签管理-特殊的查看/编辑字段 */
                    let pModule = this._findModuleById(this.operationConfig,data.pid);
                    let isTagManagePage = pModule.name=='tag_management';
                    let tagSubPage = [
                        'plat_management_page',
                        'bloc_management_page',
                        'company_management_page',
                        'account_management_page',
                        'plan_management_page',
                        'app_management_page',
                        'project_management_page',
                    ];
                    if(isTagManagePage&&tagSubPage.includes(data.name)){
                        let tagActionIdsEditable = this.tagActionIdsEditable||{};
                        let tagActionPageIds = Object.keys(tagActionIdsEditable);
                        if(val){
                            let fields = data.fields;
                            let editableFields = fields.filter(item=>{
                                let config = JSON.parse(item.config)||{};
                                return config.editable==='true';
                            });
                            tagActionIdsEditable[data.id]=editableFields.map(item=>item.id).join(',');
                        }else{
                            if(tagActionPageIds.includes(data.id)){
                                tagActionIdsEditable[data.id]='';
                            }
                        }
                    }

                }else if(data.type=='0'){
                    if(data.children&&data.children.length>0){
                        let children = data.children;
                        children.forEach(child=>{
                            this.checkAllChange(child,val);
                        })
                    }

                }
            },
            checkModuleParents(id){
                let actionData = this._findModuleById(this.operationConfig,id);
                if(actionData&&actionData.checked===false){
                    this.$set(actionData,'checked',true);
                    let pid = actionData.pid;
                    if(pid&&pid!='0'){
                        this.checkModuleParents(pid);
                    }
                }
            },
            saveDimension(data){
                console.log('saveDimension',data);
                let page = data.page||{};
                let actionData = this._findModuleById(this.operationConfig,page.id);
                let actionIds = data.actionIds||[];
                this._setFieldChecked(actionData.dimension,actionIds);
            },
            saveField(data){
                console.log('saveField',data);
                let page = data.page||{};
                let actionData = this._findModuleById(this.operationConfig,page.id);
                let actionIds = data.actionIds||[];
                this._setFieldChecked(actionData.fields,actionIds);
            },
            // 广告批量调控 智能托管
            handleSaveAdjustment(data) {
                let page = data.page||{};
                let actionData = this._findModuleById(this.operationConfig,page.id);
                let actionIds = data.actionIds||[];
                console.log('saveField',actionData, actionIds);
                this._setFieldChecked(actionData.adjustment_operation, actionIds);
            },
            saveNotifier(data){
                console.log('saveNotifier',data);
                let page = data.page||{};
                let actionData = this._findModuleById(this.operationConfig,page.id);
                let actionIds = data.actionIds||[];
                this._setFieldChecked(actionData.notifier,actionIds);
            },
            saveOptionRole(page,data){
                let actionData = this._findModuleById(this.operationConfig,page.id);
                this.$set(actionData,'optional_role_val',data.optional_role);
                this.formItem.special_config.optional_role = data.optional_role.join(',');
            },
            saveOptionTable(page,data){
                console.log('saveOptionTable',page,data);
                let actionData = this._findModuleById(this.operationConfig,page.id);
                this.$set(actionData,'optional_config_table_val',data.selected);
                this.formItem.special_config.optional_config_table = data.selected.join(',');
            },
            saveTagFields(page,viewChecked,editChecked){
                let actionData = this._findModuleById(this.operationConfig,page.id);
                this._setFieldChecked(actionData.fields,viewChecked);

                if(editChecked.length>0){
                    this.tagActionIdsEditable[page.id] = editChecked.join(',');
                }else if(this.tagActionIdsEditable[page.id]){
                    delete this.tagActionIdsEditable[page.id];
                }
            },
            savePeriod(page,data){
                let actionData = this._findModuleById(this.operationConfig,page.id);
                this._setFieldChecked(actionData.statistical_period,data.period||[]);

                let periodConfig = this.formItem.special_config.statistical_period||{};
                this.$set(periodConfig,'customize_the_latest_days',data.data_days||'');
                this.$set(periodConfig,'customize_the_start_date',data.start_date||'');
            },
            // 保存抓取数据
            handleSaveRetryData(data) {
                this.$set(this.formItem.special_config,'retry_period', data);
            },
            handleSaveDataPermissionData(page,data){
                console.log('handleSaveDataPermissionData',page,data);
                let actionData = this._findModuleById(this.operationConfig,page.id);
                let dataList = actionData.data_permission||[];
                dataList.forEach(item=>{
                    this.$set(item,'checked',item.id===data.data_permission);
                })
            },
            autoCheckFunc(page,checkArr,val){
                let actionPage = this._findModuleById(this.operationConfig,page.id);
                checkArr.forEach(item=>{
                    let func = actionPage.func||[];
                    let actionData = func.find(inner=>inner.id==item);
                    actionData&&(actionData.checked = val);
                });

                if(val){
                    this.checkModuleParents(actionPage.id);
                }
            },

            _setFieldChecked(dataList,checkedList){
                dataList.forEach(item=>{
                    this.$set(item,'checked',checkedList.includes(item.id));
                    let children = item.children||[];
                    if(children.length>0){
                        // children.forEach(child=>{
                        //     this.$set(child,'checked',checkedList.includes(child.id));
                        // })
                        this._setFieldChecked(children,checkedList);
                    }
                });
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getFixWidth)
        },
    }
</script>

<style lang="scss" scoped>
    .bg-color{
        background-color: #fff;
    }
    .header_fixed{
        position: fixed;
        z-index: 9;
        top: 50px;
        border-bottom: solid 1px #eee;
        border-top: solid 10px #F1F4F9;
    }
    .mb10{
        margin-bottom: 10px;
    }



    .form-item-title {
        color: #17233d;
        margin-bottom: 8px;
        font-weight: normal;
    }

    .text-color{
        color: #606266;
    }

    .form-footer .action-btn {
        width: 120px;
    }
    .add-role-page,.data-setting{
        min-height: 200px;
    }

    .function-tips{
        color: #515a6e;
    }


    .mb6{
        margin-bottom: 6px!important;
    }
    .border-top{
        border-top: solid 1px #d7d7d7;
    }
</style>

